<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <h4 class="mb-4">Logs de Relatórios Solicitados</h4>

        <div class="row mb-3">
          <div class="col-md-3">
            <label class="form-label">Status</label>
            <select v-model="filters.status" class="form-control" @change="loadLogs(1)">
              <option value="">Todos</option>
              <option value="pending">Na fila</option>
              <option value="processing">Gerando</option>
              <option value="completed">Concluído</option>
              <option value="failed">Falhou</option>
              <option value="no_data">Sem dados</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label">Módulo</label>
            <select v-model="filters.module" class="form-control" @change="loadLogs(1)">
              <option value="">Todos</option>
              <option value="orders">Pedidos</option>
              <option value="invoices">Financeiro</option>
              <option value="packaging">Embalagem</option>
              <option value="contracts">Contratos</option>
              <option value="contract_detail">Contrato (detalhe)</option>
            </select>
          </div>
          <div class="col-md-3 d-flex align-items-end">
            <button class="btn btn-primary" @click="loadLogs(pagination.current_page)">
              <span v-if="loading" class="fa fa-spinner fa-spin"></span>
              Atualizar
            </button>
          </div>
        </div>

        <div v-if="loading" class="text-center py-4">
          <span class="fa fa-spinner fa-spin fa-2x"></span>
        </div>

        <div v-else class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Usuário</th>
                <th>Cliente</th>
                <th>Módulo</th>
                <th>Modelo</th>
                <th>Status</th>
                <th>Linhas</th>
                <th>Solicitado em</th>
                <th>Início</th>
                <th>Conclusão</th>
                <th>Duração</th>
                <th>Erro</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="logs.length === 0">
                <td colspan="12" class="text-center text-muted">Nenhum log encontrado.</td>
              </tr>
              <tr v-for="log in logs" :key="log.id">
                <td>{{ log.id }}</td>
                <td>{{ log.user ? log.user.name : '-' }}</td>
                <td>{{ log.customer ? log.customer.name : '-' }}</td>
                <td>{{ moduleLabel(log.module) }}</td>
                <td>{{ log.model || '-' }}</td>
                <td><span class="badge" :class="statusBadgeClass(log.status)">{{ statusLabel(log.status) }}</span></td>
                <td>{{ log.row_count ?? 0 }}</td>
                <td>{{ formatDate(log.created_at) }}</td>
                <td>{{ formatDate(log.started_at) }}</td>
                <td>{{ formatDate(log.completed_at) }}</td>
                <td>{{ formatDuration(log.duration_ms) }}</td>
                <td class="small text-danger">{{ log.error_message || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3" v-if="pagination.last_page > 1">
          <span>Página {{ pagination.current_page }} de {{ pagination.last_page }}</span>
          <div>
            <button class="btn btn-sm btn-outline-primary me-2" :disabled="pagination.current_page <= 1"
              @click="loadLogs(pagination.current_page - 1)">Anterior</button>
            <button class="btn btn-sm btn-outline-primary" :disabled="pagination.current_page >= pagination.last_page"
              @click="loadLogs(pagination.current_page + 1)">Próxima</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      logs: [],
      filters: {
        status: '',
        module: '',
      },
      pagination: {
        current_page: 1,
        last_page: 1,
      },
      pollInterval: null,
    };
  },
  mounted() {
    this.loadLogs(1);
    this.pollInterval = setInterval(() => this.loadLogs(this.pagination.current_page, true), 10000);
  },
  beforeUnmount() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
  },
  methods: {
    loadLogs(page = 1, silent = false) {
      if (!silent) {
        this.loading = true;
      }

      const params = new URLSearchParams({
        page: page,
        per_page: 25,
      });

      if (this.filters.status) params.append('status', this.filters.status);
      if (this.filters.module) params.append('module', this.filters.module);

      axios
        .get(this.$store.getters.api + 'report-export-logs?' + params.toString())
        .then((response) => {
          const payload = response.data.data;
          this.logs = payload.data || [];
          this.pagination.current_page = payload.current_page || 1;
          this.pagination.last_page = payload.last_page || 1;
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar logs de relatórios');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    moduleLabel(module) {
      const labels = {
        orders: 'Pedidos',
        invoices: 'Financeiro',
        packaging: 'Embalagem',
        contracts: 'Contratos',
        contract_detail: 'Contrato (detalhe)',
      };
      return labels[module] || module;
    },
    statusLabel(status) {
      const labels = {
        pending: 'Na fila',
        processing: 'Gerando',
        completed: 'Concluído',
        failed: 'Falhou',
        no_data: 'Sem dados',
      };
      return labels[status] || status;
    },
    statusBadgeClass(status) {
      const classes = {
        pending: 'bg-secondary',
        processing: 'bg-info',
        completed: 'bg-success',
        failed: 'bg-danger',
        no_data: 'bg-warning text-dark',
      };
      return classes[status] || 'bg-secondary';
    },
    formatDate(value) {
      if (!value) return '-';
      return new Date(value).toLocaleString('pt-BR');
    },
    formatDuration(ms) {
      if (!ms) return '-';
      if (ms < 1000) return ms + ' ms';
      return (ms / 1000).toFixed(1) + ' s';
    },
  },
};
</script>
